import CTAS from 'react-scale/components/elements/cta';
import Logo from 'react-scale/components/website/Logo';
import Image from 'next/image';
import cn from 'classnames';
import MeshGradient from 'react-scale/components/elements/webgl/mesh-gradient';

const HeroImageOverflowing = ({ className, asset }) => (
  <div className={cn('relative text-center w-full flex-[0]', className)}>
    <div className="relative mx-auto flex w-full lg:hidden max-w-max">
      <Image
        className="rounded-xl"
        quality={100}
        layout="intrinsic"
        width={asset.width}
        height={asset.height}
        src={asset.src}
        alt={asset.alt}
        unoptimized
        priority
      />
    </div>
    <div className="hidden lg:flex">
      <Image
        className="rounded-xl"
        quality={100}
        layout="fixed"
        width={asset.width}
        height={asset.height}
        src={asset.src}
        alt={asset.alt}
        unoptimized
        priority
      />
    </div>
  </div>
);

const HeroProduct = ({ logo, title, subtitle, asset, cta, spacing }) => (
  <div className="relative overflow-hidden">
    <div className="absolute z-0 inset-0 overflow-hidden max-w-[100vw]">
      <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
      <div className="absolute inset-0 bottom-2/3 w-full bg-gradient-to-b from-black" />
      <MeshGradient
        style={{
          '--gradient-color-1': '#D1AAD7',
          '--gradient-color-2': '#5933b2',
          '--gradient-color-3': '#8349FF',
          '--gradient-color-4': '#7B8CE7'
        }}
      />
    </div>
    <div className="relative">
      <div
        className={cn(
          'container flex items-center justify-between w-full py-18 space-x-16',
          asset.overflowing ? 'lg:pt-24 lg:pb-32' : 'lg:pt-40 lg:pb-44'
        )}
      >
        <div className="relative w-full lg:w-auto lg:min-w-max flex-grow-1">
          <div className="relative lg:min-w-max">
            <div className="flex flex-col lg:flex-row items-center justify-center lg:items-stretch lg:justify-start">
              {logo && (
                <>
                  <span className="lg:hidden mb-6">
                    <Image src={logo.src} alt={logo.alt} width="70" height="81" />
                  </span>
                  <span className="hidden select-none lg:flex">
                    <Image src={logo.src} width={logo.width} height={logo.height} alt={logo.alt} />
                  </span>
                </>
              )}
              <div
                className={cn(
                  'flex flex-col lg:block justify-center items-center',
                  asset && logo ? 'lg:ml-8' : 'lg:ml-0'
                )}
              >
                <div className="lg:hidden mb-4">
                  <Logo width="68px" fillmobile="#A3A3A3" />
                </div>
                <div className={cn('hidden lg:block', asset ? 'mb-2' : 'mb-12')}>
                  <Logo width="100px" fill="#A3A3A3" />
                </div>
                <h1
                  className={cn(
                    'font-aeonik text-4xl leading-[45px] lg:leading-10 xl:text-6xl md:text-5xl'
                  )}
                >
                  {title}
                </h1>
              </div>
            </div>
            <p className="my-12 sm:px-0 text-lg leading-8 max-w-md text-center mx-auto lg:mx-0 lg:text-left lg:text-2xl lg:leading-10 lg:font-aeonik lg:mt-4">
              {subtitle}
            </p>
            {asset.overflowing ? (
              <HeroImageOverflowing className="lg:hidden" asset={asset} />
            ) : (
              <div className="lg:hidden flex mt-16">
                <Image
                  className="rounded-lg"
                  src={asset.src}
                  layout="intrinsic"
                  alt={asset.alt}
                  width={asset.width}
                  height={asset.height}
                  quality={100}
                />
              </div>
            )}
            <div
              className={cn(
                'flex mx-auto mt-16 lg:mt-10 gap-x-8 w-full sm:max-w-max lg:max-w-none',
                asset ? 'lg:mt-7' : 'lg:mt-12'
              )}
            >
              <CTAS cta={cta} />
            </div>
          </div>
        </div>

        {asset.overflowing ? (
          <HeroImageOverflowing
            className={cn(
              { 'ml-32': spacing === 'md', 'ml-8': spacing === 'sm' },
              'hidden lg:block'
            )}
            asset={asset}
          />
        ) : (
          <div className="ml-10 hidden lg:flex">
            <Image
              className="rounded-lg"
              src={asset.src}
              layout="intrinsic"
              alt={asset.alt}
              width={asset.width}
              height={asset.height}
              quality={100}
            />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default HeroProduct;
